import React, { useState, useEffect} from 'react';
import axios from "axios";

import query_img from './images/query_img.png';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { enquirysubmit, coursedetails } from './Api_list';
let slug1 = document.URL.split("/")[3];
let slug2 = document.URL.split("/")[4];
let color = {};
const Query_form = () => {
  var headerData = {"headers":{
    "Accept": "application/json",
    "Content-Type": "application/json", 
    "authorization": window.HEADERSAUTH,
  }} 
    const [name, setName] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [emailid, setEmailid] = useState("");
    const [message, setMessage] = useState("");
    const [ post, setPost ] = React.useState( null );
    React.useState(()=>{
      
        axios.get(coursedetails+slug1+'&course_slug='+slug2, headerData).then((response)=>{
            setPost( response.data )
        })
    }, []);
    if( !post ) return null;
    let getData = post.data;
  let handleSubmit = async (e) => {
    e.preventDefault();
    const post = {
      full_name     : name,
      email_id      : setEmailid, 
      looking_for   : "",
      type          : 'university',
      university_name   : getData.univ_name,
      course_name          : getData.c_course_name,
      mobile_no     : mobileNumber,
    } 
  if((name.length != 0) && (mobileNumber.length === 10)){
    try {
      const res = await axios.post(enquirysubmit, post, headerData)
      if (res.status === 200) {
        color.color = 'white';
        setName("");setMobileNumber("");setEmailid("");
            setMessage('Thank you, your call back request has been submitted successfully!');
            setTimeout(() => {
              setMessage('');
            }, 5000);
          } else {
            color.color = 'red';
            setMessage("Some error occured");
            setTimeout(() => {
              setMessage('');
            }, 5000);
          }
    } catch (e) {
      color.color = 'red';
      setMessage("Some error occured");
      setTimeout(() => {
        setMessage('');
      }, 5000);
    }
  }else{
    color.color = 'red';
    setMessage("Please enter valid mobile number"); 
    setTimeout(() => {
      setMessage('');
    }, 5000);
  }
  };

    return (
        <>
            <div className='qryform'>
                <div className='qry_img'>
                    <img src={query_img} />
                </div>
                <Form onSubmit={handleSubmit}>
                <div className="message">{message ? <p style={color}>{message}</p> : null}</div> 
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Control type="text" onChange={(e) => setName(e.target.value)} value={name} placeholder="Full Name" />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Control type="email" onChange={(e) => setEmailid(e.target.value)} value={emailid} placeholder="Enter email" />
                    </Form.Group>
                    <InputGroup className="mb-3">
                        <InputGroup.Text id="inputGroup-sizing-default">
                            +91
                        </InputGroup.Text>
                        <Form.Control
                        onChange={(e) => setMobileNumber(e.target.value)} value={mobileNumber} maxLength={10}
                            aria-label="Default"
                            aria-describedby="inputGroup-sizing-default"
                        />
                    </InputGroup>
                    <Button variant="primary" type="submit">
                        Submit
                    </Button>
                    <Form.Text className="text-muted">
                        By providing your contact details, you agree to our <a href='/terms-and-conditions'> Terms of Use</a> & <a href='/privacy-policy'>Privacy Policy</a>
                    </Form.Text>
                </Form>
            </div>
        </>
    );
}

export default Query_form;